import React from "react";
import CanadaFlag from "assets/images/canada-flag.png";
import { FEATURES } from "pages/dtf-transfers/gang-sheet/data";
import { getSheetUnitPrice } from "pages/dtf-transfers/gang-sheet/helpers";
import {
  PricingLine,
  FeatureGrid,
  FeatureItem,
} from "styles/pages/dtf-transfers/gang-sheet";

const ProductHeader = ({ sheetWidth, sheetHeight }) => {
  const unitPrice = getSheetUnitPrice(sheetWidth, sheetHeight);

  return (
    <>
      <PricingLine>
        <strong>
          From ${unitPrice.toFixed(2)} ({sheetWidth}" × {sheetHeight}")
        </strong>{" "}
        | $0.01/sq in | Printed by Shirtly.
      </PricingLine>

      <FeatureGrid>
        {FEATURES.map(({ icon: Icon, label }) => (
          <FeatureItem key={label}>
            <Icon />
            <span>{label}</span>
          </FeatureItem>
        ))}
      </FeatureGrid>
    </>
  );
};

export default ProductHeader;
